import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SellerEntitiesFactory} from '../Entities/factory.js'
import {GetInstantOfferDetailsGenericSellerError} from '../Errors/GetInstantOfferDetailsGenericSellerError.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'

class GetInstantOfferDetailsSellerUseCase extends UseCase {
  #instantOfferEntityFactory
  #repository

  constructor({instantOfferEntityFactory, repository}) {
    super()
    this.#instantOfferEntityFactory = instantOfferEntityFactory
    this.#repository = repository
  }

  static create({config}) {
    return new GetInstantOfferDetailsSellerUseCase({
      instantOfferEntityFactory: SellerEntitiesFactory.instantOfferSellerEntity,
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config})
    })
  }

  /**
   * @param {Object} params
   * @param {String} params.instantOfferId
   * @return {Promise}
   */
  @tracer({metric: 'GetInstantOfferDetailsSellerUseCase#execute'})
  @inlineError
  execute({instantOfferId} = {}) {
    if (!instantOfferId)
      return Promise.reject(
        new GetInstantOfferDetailsGenericSellerError('GetInstantOfferDetailsSellerUseCase: instantOfferId is required')
      )

    const instantOfferEntity = this.#instantOfferEntityFactory({instantOfferId})

    return this.#repository.getInstantOfferDetails({instantOfferEntity}).then(([error, instantOfferDetailsVO]) => {
      if (error) return Promise.reject(error)
      return instantOfferDetailsVO.toJSON()
    })
  }
}

export const factory = GetInstantOfferDetailsSellerUseCase.create
